/** Application version */
export const APP_VERSION = '0.0.0';

/** Feedback recipients */
export const FEEDBACK_EMAILS: string[] = [
  'priyanshu.bisht@vibracoustic.com',
  'vishant.chhabra@vibracoustic.com',
];

/** API base URL — overridden via VITE_API_BASE_URL env variable in production. */
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ?? '/api';
